module.exports = __webpack_public_path__ + "static/media/QUICK-UNI.dcf0bc5c.png";